import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import "../Styling/StationMaster.css";

const StationMaster = () => {
  const { user } = useAuth();

  const [station, setStation] = useState("");
  const [stations, setStations] = useState([]);

  // =========================
  // 1️⃣ FETCH STATIONS
  // =========================
  const fetchStations = async () => {
    if (!user?.organisationId) return;

    try {
      const response = await axios.get(
        `${Base_URL}/StationMaster/${user.organisationId}`
      );

      // Station API returns direct array (not success wrapper)
      setStations(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching stations:", error);
      setStations([]);
    }
  };

  useEffect(() => {
    fetchStations();
  }, [user]);

  // =========================
  // 2️⃣ ADD STATION
  // =========================
  const handleAdd = async () => {
    if (!station.trim()) return;
  
    if (!user?.organisationId) {
      console.log("User not loaded yet");
      return;
    }
  
    const payload = {
      StationName: station.trim(),
      organistionId: user.organisationId, // keep backend spelling
      CreatedBy: user.username,
    };
  
    try {
      console.log("POSTING:", payload);
  
      const res = await axios.post(`${Base_URL}/StationMaster`, payload);
  
      console.log("RESPONSE:", res.data);
  
      setStation("");
      fetchStations();
    } catch (error) {
      console.log("POST ERROR:", error.response?.data || error.message);
    }
  };
  

  // =========================
  // 3️⃣ DELETE STATION
  // =========================
  const removeStation = async (guid) => {
    try {
      await axios.delete(
        `${Base_URL}/StationMaster/${guid}/${user.userName}`
      );

      // instant UI removal
      setStations((prev) => prev.filter((s) => s.recordGuid !== guid));
    } catch (error) {
      console.error("Error deleting station:", error);
    }
  };

  return (
    <div className="stationMaster">
      <div className="stationMaster__card stationMaster__titleCard">
        <h2>Station Master</h2>
      </div>

      <div className="stationMaster__card stationMaster__inputCard">
        <div className="stationMaster__field">
          <label>Station Name</label>
          <input
            type="text"
            value={station}
            onChange={(e) => setStation(e.target.value)}
            placeholder="Enter station"
          />
        </div>

        <button className="stationMaster__primaryBtn" onClick={handleAdd}>
          Submit
        </button>
      </div>

      {/* ================= VIEW SECTION ================= */}
      <div className="stationMaster__card">
        <h4>View Stations</h4>

        <div className="stationMaster__chipContainer">
          {stations.length === 0 ? (
            <p className="stationMaster__empty">No stations found</p>
          ) : (
            stations.map((st) => (
              <div
                key={st.recordGuid}
                className="stationMaster__chip stationMaster__viewChip"
              >
                {st.stationName}

                <span
                  className="stationMaster__cross"
                  onClick={() => removeStation(st.recordGuid)}
                >
                  ✕
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default StationMaster;
